<template>
  <v-container class="outerContainer">
    <!-- dialogs -->    
    <help-content
      :show="showHelpPanel"
      v-on:did-select-ok="didCloseHelp"
    ></help-content>

    <v-layout row wrap>
      <v-flex xs12>

        <!-- intro content -->
        <div class="logo mt-4 mb-4">
          <img src="@/assets/jll-logo.png">
        </div>
		
        <div class="intro">
            <div>Network Analysis Calculator</div>

            <div class="description">
              Leverage Real Estate to Maximize Supply Chain Efficiencies
            </div>
        </div>



        <div class="body mt-5 mb-5">
            <div class="highlight mb-4">
              For every $1 you spend on rent, you are also spending
            </div>
            <div class="costs-row">
              <div class="cost-block">
                <div>$2</div>
                <div>on Labor</div>
              </div>
              <div sm1 class="arrow-icon">
              </div>
              <div sm2 xs12 class="cost-block">
                <div>$4</div>
                <div>on Inventory</div>
              </div>
              <div sm1 class="arrow-icon">
              </div>
              <div sm2 xs12 class="cost-block">
                <div>$10</div>
                <div>on Freight</div>
              </div>
            </div>
        </div>



        <div class="navAction">
          <div class="actionText">See how your logistics spend breaks down</div>
          <v-layout row>
            <v-flex xs12 class="mb-3">
              <div
                class="actionButton"
                @click="showHelp"
              >
                <div class="idea-icon icon"></div>
                <div>
                  Learn More
                </div>
              </div>

              <div
                class="actionButton"
                @click="scrollToApp('/analyzer')"
              >
                <div class="world-icon icon"></div>
                <div>
                  Network Builder
                </div>
              </div>


              <div
                class="actionButton"
                @click="scrollToApp('/calculator')"
              >
                <div class="bar-graph-icon icon"></div>
                <div>
                  Site Selector
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      name: "introduction",
      showHelpPanel: false,
      authenticated: false,
      authenticatedPromise: null
    }
  },

  props: [ 
    "fullpageController" 
  ],
  
  mounted() {
    this.authenticatedPromise = new Promise((resolve) => {
      setTimeout(async () => {
        this.authenticated = await this.$auth.isAuthenticated()
        resolve(this.authenticated)
      }, 100)
    })
  },

  methods: {
    scrollToApp: function(path) { 
      if(!this.authenticatedPromise) return
      this.authenticatedPromise.then(() => {
        if(this.authenticated){
          this.$parent.$parent.$data.pagingEnabled = true
          this.fullpageController().moveNext()
          this.$router.push({ path: path})
        } else {
          this.$auth.loginRedirect('/')
        }
      })
    },
    showHelp() {
      this.showHelpPanel = true
    },
    didCloseHelp() {
      this.showHelpPanel = false
    }
  },

  computed: {
  },

  components: {
    'intro-bar': () => import ('@/components/IntroBar'),
    'help-content': () => import ('@/components/HelpContent')
  }
}

</script>


<style scoped>
@font-face {
  font-family:"JLL Hand";
  src: 
    url("../assets/fonts/jll-hand/jll-hand-webfont.woff") format("woff"),
    url("../assets/fonts/jll-hand/jll-hand-webfont.woff2") format("woff2");
}


.intro {
  color: black;
  text-align: center;
  font-size: 36pt;
}
.intro div:nth-child(1){
  font-family:'JLL Hand', Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
}
.description {
  font-weight: 300;
  font-size: 16pt;
}
.sub-description {
  font-size: 12pt;
}
.actionButton {
  width: 200px;
  color: #000000;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-transform: none;
  font-weight: 300;
  font-size: 14pt;
  vertical-align: top;
}
.actionButton div:nth-child(2) {
  line-height:1.2;
  vertical-align: middle;
}
.actionButton:hover {
  color: #1976d2;
}
.actionButton .v-icon {
  font-size: 2.2em;
  text-align: left;
  vertical-align: middle;
  height: 100%;
}
.actionButton .icon {
  margin: 0 auto;
  width: 90px;
  height: 90px;
}
.actionButton:hover .idea-icon {
  background: url("../assets/icons/idea_blue.svg") no-repeat center center;
}
.actionButton:hover .bar-graph-icon {
  background: url("../assets/icons/bar_graph_blue.svg") no-repeat center center;
}
.actionButton:hover .world-icon {
  background: url("../assets/icons/world_blue.svg") no-repeat center center;
}
.actionText {
  color: #000000;
  font-size: 13pt;
  font-weight: 300;
  margin: 2% auto;
}
.content {
  width: 100%;
  height: 300px;
  background-color:white;
}
.body {
  color: #000000;
  font-size: 16pt;
}
.body .flex.sm2 {
  flex-basis: 12.5%;
  max-width:12.5%;
}
.costs-row >div {
  display: inline-block;
}
.cost-block {
  margin: 0 15px;
}
.cost-block div:nth-child(1){
  font-size: 2.4em;
  font-weight: 600;
}
.cost-block div:nth-child(2){
  font-size: 0.8em;
  font-weight: 300;
}
.arrow-icon {
  background: url("../assets/icons/arrows.svg") no-repeat center center;
  width:70px;
  height:100px;
  margin-right: 5px;
}
.idea-icon {
  background: url("../assets/icons/idea.svg") no-repeat center center;
}
.bar-graph-icon {
  background: url("../assets/icons/bar_graph.svg") no-repeat center center;
}
.world-icon {
  background: url("../assets/icons/world.svg") no-repeat center center;
}
.highlight {
  font-weight: 600;
}
.bar {
  height: 60px;
  width: 100%;
  background-color:black;
}
.outerContainer {
  font-family: 'Source Sans Pro', Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
  position: relative;
  height: 100%;
}

.navAction {
  margin: 0 auto;
}

.navAction .horizontal-rule {
  border-bottom: 1px solid #888888;
  margin: auto;
  margin-bottom: 25px;
  width: 60%;
}

@media only screen and (max-width: 800px) {
  .intro {
  }
  .content {
    font-size: 12pt;
  }
}

@media only screen and (max-width: 670px) {
  .intro {
  }
}

@media only screen and (max-height: 670px) {
  .actionText {
  }
  .intro {
  }
}
</style>
<style>
@media only screen and (max-width: 670px) {
  .intro-page.page {
    overflow-y: auto;
  }
}
</style>